<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.productName"
              placeholder="请输入品规名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @batchImport="batchImportFun"
        @add="addFun"
        @edit="editFun(arguments)"
        @del="delFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 批量导入 弹框组件 -->
    <import-excel
      :dialog-visible.sync="dialogImportVisible"
      :action="action"
      :data="importData"
      :dialog-import-title="dialogImportTitle"
      @showErr="changeDialogErrorVisible"
      @reloadData="loadTableData()"
    />
    <import-error-dialog
      :dialog-visible.sync="dialogErrorVisible"
      :message-data="messageData"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 批量导入数据 组件
import importExcel from './components/importExcel'
// 批量导入数据 格式错误 组件
import importErrorDialog from '@/components/ImportErrDialog'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 数据请求
import { loadMarketProductPlanListDataApi, loadMarketProductPlanExportDataApi, saveOrUpdateMarketProductPlanApi } from '@/api/marketProductPlan'
export default {
  name: 'MarketProductPlan',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog,
    importExcel,
    importErrorDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'base_market_product_plan_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['market_product_plan_add'],
            prop: 'batchImport',
            label: '批量导入',
            method: 'batchImport'
          },
          // {
          //   permissionSigns: ['market_product_plan_add'],
          //   prop: 'add',
          //   label: '新增',
          //   method: 'add'
          // },
          {
            permissionSigns: ['market_product_plan_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['market_product_plan_del'],
            prop: 'del',
            label: '批量作废',
            method: 'del'
          },
          {
            permissionSigns: ['market_product_plan_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['market_product_plan_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            productName: ''
          }
        },
        notPaging: true
      },
      id: null, // 选中的单据ID
      dialogSetPersmissionVisible: false, // 设置权限
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      eventType: '',
      /* 批量导入数据相关 */
      action: process.env.VUE_APP_BASE_API + '/web/marketProductPlan/saveByImportExcel', // 访问API
      importData: null, // 批量导入时需额外传入的参数
      dialogImportVisible: false,
      dialogImportTitle: '导入销售规划',
      dialogErrorVisible: false, // 导入出错信息弹框是否显示
      messageData: [] // 导入出错信息
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'year', label: '年份', width: 100 },
      { prop: 'month', label: '月份', width: 100 },
      { prop: 'cityName', label: '区域', filterColumn: 'city_name', width: 120 },
      { prop: 'productName', label: '品规', filterColumn: 'product_name', width: 160 },
      { prop: 'amount', label: '数量', width: 120 },
      { prop: 'remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 120 },
      { prop: 'operationTimeStr', filterColumn: 'operation_time', label: '操作时间', width: 180, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadMarketProductPlanListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 批量导入
    batchImportFun () {
      this.dialogImportVisible = !this.dialogImportVisible
    },
    //新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '新增销售规划'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '修改销售规划'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '查看销售规划'
    },
    // 作废
    delFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定批量作废' + args[0].year + '年' + args[0].month + '月的销售规划数据？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        this.masterList.tableLoading = true
        saveOrUpdateMarketProductPlanApi({ id: args[0].id, year: args[0].year, month: args[0].month, status: 0, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导入错误时
    changeDialogErrorVisible (msg) {
      this.dialogErrorVisible = true
      this.messageData = msg
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadMarketProductPlanExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
